import { Icon, TableHead, Text, Tooltip, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';

import { columnWidthsHeadDesktop } from '../constants';

import { TitleItem } from './TitleItem';

export const Head = () => {
  const TextItem = ({ item }: { item: string }) => {
    return (
      <Text
        width={'100%'}
        variant="semibold"
        lineHeight="distant"
        numberOfLines={1}
        py={Spacing['inline.nano']}
        pl={Spacing['inline.nano']}
        textAlign={'start'}
        flex={1}>
        {item}
      </Text>
    );
  };

  return (
    <TableHead paddingX={Spacing['inset.xs']} justifyContent={'space-between'} testId="header">
      <TitleItem width={columnWidthsHeadDesktop.paper}>
        <TextItem item={'Papel'} />
      </TitleItem>
      <TitleItem width={columnWidthsHeadDesktop.date}>
        <TextItem item={'Data'} />
      </TitleItem>
      <TitleItem width={columnWidthsHeadDesktop.purchaseQty}>
        <TextItem item={'Qtd. Compra '} />
      </TitleItem>
      <TitleItem width={columnWidthsHeadDesktop.saleQty}>
        <TextItem item={'Qtd. Venda '} />
      </TitleItem>
      <TitleItem width={columnWidthsHeadDesktop.executedQty}>
        <TextItem item={'Qtd. Executada '} />
      </TitleItem>
      <TitleItem width={columnWidthsHeadDesktop.position}>
        <Tooltip
          flex={1}
          width={'100%'}
          label={
            'Entenda a posição.\n0 - Não há posição em aberto\n1 > Quantidade restante comprado\n0 < Quantidade restante vendido'
          }
          testId={'tooltipe-header'}>
          <HStack minWidth={'100%'} alignItems={'center'} flex={1}>
            <Icon name="Info" color={Color['neutral.dark']} size="xxxs" testId="status-icon" />
            <TextItem item={'Posição'} />
          </HStack>
        </Tooltip>
      </TitleItem>
      <TitleItem width={columnWidthsHeadDesktop.operation}>
        <TextItem item={'Operação'} />
      </TitleItem>
    </TableHead>
  );
};
